import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import { getCompanyProfileList, getRoleInfo, saveRole, getCompanyModuleMapping } from '../../services/user.service';
import { getAppModuleList, getAppSubModuleList, getModuleList, getSubModuleList } from '../../services/master.service';
import * as CryptoJS from "crypto-js";

import './role.css';

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,255}$/;

function Role() {
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [companyId, setCompanyId] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState(false);

    const [rolename, setRoleName] = useState('');
    const [ErrRoleName, setErrRoleName] = useState(false);

    const [roleshortname, setRoleShortName] = useState('');
    const [ErrRoleShortName, setErrRoleShortName] = useState(false);

    const [roledescription, setRoleDescription] = useState('');
    const [ErrRoleDescription, setErrRoleDescription] = useState(false);

    const [isChatbotEnabled, setIsChatbotEnabled] = useState('0');

    const [modules, setModules] = useState([]);
    const [subModules, setSubModules] = useState([]);
    const [appModules, setAppModules] = useState([]);
    const [appSubModules, setAppSubModules] = useState([]);

    const [roleModules, setRoleModules] = useState([]);
    const [roleSubModules, setRoleSubModules] = useState([]);
    const [roleAppModules, setRoleAppModules] = useState([]);
    const [roleAppSubModules, setRoleAppSubModules] = useState([]);

    const [companies, setCompanies] = useState([]);
    const [activeTab, setActiveTab] = useState(1);

    const [modinfo, setModinfo] = useState({ modls: [], response: [] });
    const [subModinfo, setSubModinfo] = useState({ submodls: [], response: [] });
    const [app_modinfo, setAppModinfo] = useState({ app_modls: [], response: [] });
    const [app_subModinfo, setAppSubModinfo] = useState({ app_submodls: [], response: [] });

    const [compMappedMod, setCompMappedMod] = useState([]);
    const [compMappedSub, setCompMappedSub] = useState([]);
    const [compMappedAppMod, setCompMappedAppMod] = useState([]);
    const [compMappedAppSub, setCompMappedAppSub] = useState([]);

    // Track which module blocks are expanded (by "web-ID" or "app-ID" key)
    const [expandedModules, setExpandedModules] = useState({});

    const validateTab1AndProceed = (targetTab) => {
        let valid_Name = true;
        if (!companyId || companyId === "") { setErrCompanyId('Company name is required'); valid_Name = false; } else { setErrCompanyId(''); }
        if (!TEXT_REGEX.test(rolename)) { setErrRoleName('Role name is required'); valid_Name = false; } else { setErrRoleName(''); }
        if (!TEXT_REGEX.test(roledescription)) { setErrRoleDescription('Role description is required'); valid_Name = false; } else { setErrRoleDescription(''); }
        if (!TEXT_REGEX.test(roleshortname)) { setErrRoleShortName('Role short name is required'); valid_Name = false; } else { setErrRoleShortName(''); }

        if (valid_Name) {
            setActiveTab(targetTab);
        }
    };

    const handleTabChange11 = (tabNumber) => {
        if (activeTab === 1 && tabNumber !== 1) {
            validateTab1AndProceed(tabNumber);
        } else {
            setActiveTab(tabNumber);
        }
    };

    const resetUserInfo = () => {
        setRoleName('');
        setRoleShortName('');
        setRoleDescription('');
        setCompanyId('');
        setIsChatbotEnabled('0');
    };

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Roleid = query.get('roleid');
    const compid = query.get('compid');
    const elementRef = useRef();

    useEffect(() => {
        if (Roleid !== '' && Roleid !== null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Roleid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            getRoleInfoData(decrypt_data.roleid);
        }

        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        getCompanyProfileList(oData).then(res => { if (res?.data?.data?.length) setCompanies(res.data.data); });
        getModuleList(oData).then(res => { if (res?.data?.data?.length) setModules(res.data.data); });
        getSubModuleList(oData).then(res => { if (res?.data?.data?.length) setSubModules(res.data.data); });
        getAppModuleList(oData).then(res => { if (res?.data?.data?.length) setAppModules(res.data.data); });
        getAppSubModuleList(oData).then(res => { if (res?.data?.data?.length) setAppSubModules(res.data.data); });
    }, []);

    useEffect(() => {
        setModinfo(prev => ({ ...prev, modls: roleModules, response: roleModules }));
        setSubModinfo(prev => ({ ...prev, submodls: roleSubModules, response: roleSubModules }));
        setAppModinfo(prev => ({ ...prev, app_modls: roleAppModules, response: roleAppModules }));
        setAppSubModinfo(prev => ({ ...prev, app_submodls: roleAppSubModules, response: roleAppSubModules }));
    }, [roleModules, roleSubModules, roleAppModules, roleAppSubModules]);

    useEffect(() => {
        if (companyId && companyId !== "") {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'company_id': companyId },
                'company_id': companyId,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token': EncryptData };

            getCompanyModuleMapping(oData).then(res => {
                if (res?.data?.data?.length) {
                    const mapping = res.data.data[0];
                    setCompMappedMod(mapping.module_id && mapping.module_id !== "" ? mapping.module_id.split(',').map(Number) : []);
                    setCompMappedSub(mapping.sub_module_id && mapping.sub_module_id !== "" ? mapping.sub_module_id.split(',').map(Number) : []);
                    setCompMappedAppMod(mapping.app_module_id && mapping.app_module_id !== "" ? mapping.app_module_id.split(',').map(Number) : []);
                    setCompMappedAppSub(mapping.app_sub_module_id && mapping.app_sub_module_id !== "" ? mapping.app_sub_module_id.split(',').map(Number) : []);
                } else {
                    setCompMappedMod([]);
                    setCompMappedSub([]);
                    setCompMappedAppMod([]);
                    setCompMappedAppSub([]);
                }
            });
        } else {
            setCompMappedMod([]);
            setCompMappedSub([]);
            setCompMappedAppMod([]);
            setCompMappedAppSub([]);
        }
    }, [companyId]);

    const getRoleInfoData = (decryptedRoleid) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'role_id': decryptedRoleid },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        getRoleInfo({ 'token': EncryptData }).then(res => {
            if (res?.data?.data) {
                const roleInfo = res.data.data[0];
                setCompanyId(roleInfo.company_id);
                setRoleName(roleInfo.role_name);
                setRoleShortName(roleInfo.role_short_name);
                setRoleDescription(roleInfo.role_details);
                setIsChatbotEnabled(roleInfo.is_chatbot_enabled || '0');
                setRoleModules(roleInfo.module_id.split(',').map(Number));
                setRoleSubModules(roleInfo.sub_module_id.split(',').map(Number));
                setRoleAppModules(roleInfo.app_module_id.split(',').map(Number));
                setRoleAppSubModules(roleInfo.app_sub_module_id.split(',').map(Number));
            }
        });
    };

    const modulesData = modules.filter(item => compMappedMod.includes(Number(item.id))).map(item => ({
        id: item.id,
        module_name: item.module_name,
        subMdlData: subModules.filter(sub => sub.module_id === item.id && compMappedSub.includes(Number(sub.id))).map(sub => ({
            id: sub.id,
            module_id: sub.module_id,
            sub_module_name: sub.sub_module_name,
        })),
    }));

    const appModulesData = appModules.filter(item => compMappedAppMod.includes(Number(item.id))).map(item => ({
        id: item.id,
        module_name: item.module_name,
        appSubMdlData: appSubModules.filter(sub => sub.module_id === item.id && compMappedAppSub.includes(Number(sub.id))).map(sub => ({
            id: sub.id,
            module_id: sub.module_id,
            sub_module_name: sub.sub_module_name,
        })),
    }));

    const handleCompanyId = (e) => setCompanyId(e.target.value);

    /* ── expand / collapse toggle ─────────────────────────── */
    const toggleExpand = (key) => {
        setExpandedModules(prev => ({ ...prev, [key]: !prev[key] }));
    };

    /* ── module checkbox — also toggles all sub-modules ────── */
    const handleChange = (e, subMdlData) => {
        const { value, checked } = e.target;
        const moduleId = Number(value);
        const subIds = subMdlData.map(s => s.id);

        setModinfo(prev => ({
            ...prev,
            modls: checked ? [...prev.modls, moduleId] : prev.modls.filter(m => m !== moduleId),
            response: checked ? [...prev.response, moduleId] : prev.response.filter(m => m !== moduleId),
        }));
        setRoleModules(prev => checked ? [...prev, moduleId] : prev.filter(m => m !== moduleId));

        setSubModinfo(prev => {
            const filtered = prev.submodls.filter(s => !subIds.includes(s));
            const updated = checked ? [...filtered, ...subIds] : filtered;
            return {
                ...prev,
                submodls: updated,
                response: updated,
            };
        });
        setRoleSubModules(prev => {
            const filtered = prev.filter(s => !subIds.includes(s));
            return checked ? [...filtered, ...subIds] : filtered;
        });
    };

    /* ── individual sub-module toggle ────────────────────────  */
    const handleSubMdlChange = (e) => {
        const { value, checked } = e.target;
        const subId = Number(value);
        setSubModinfo(prev => ({
            ...prev,
            submodls: checked ? [...prev.submodls, subId] : prev.submodls.filter(s => s !== subId),
            response: checked ? [...prev.response, subId] : prev.response.filter(s => s !== subId),
        }));
        setRoleSubModules(prev => checked ? [...prev, subId] : prev.filter(s => s !== subId));
    };

    /* ── app module checkbox — also toggles all app sub-modules */
    const handleAppModuleChange = (e, appSubMdlData) => {
        const { value, checked } = e.target;
        const moduleId = Number(value);
        const subIds = appSubMdlData.map(s => s.id);

        setAppModinfo(prev => {
            const updatedMods = checked ? [...(prev.app_modls || []), moduleId] : (prev.app_modls || []).filter(m => m !== moduleId);
            return { ...prev, app_modls: updatedMods, response: updatedMods };
        });
        setRoleAppModules(prev => checked ? [...prev, moduleId] : prev.filter(m => m !== moduleId));

        setAppSubModinfo(prev => {
            const filtered = (prev.app_submodls || []).filter(s => !subIds.includes(s));
            const updated = checked ? [...filtered, ...subIds] : filtered;
            return { ...prev, app_submodls: updated, response: updated };
        });
        setRoleAppSubModules(prev => {
            const filtered = prev.filter(s => !subIds.includes(s));
            return checked ? [...filtered, ...subIds] : filtered;
        });
    };

    /* ── individual app sub-module toggle ────────────────────  */
    const handleAppSubMdlChange = (e) => {
        const { value, checked } = e.target;
        const subId = Number(value);
        setAppSubModinfo(prev => {
            const updated = checked ? [...(prev.app_submodls || []), subId] : (prev.app_submodls || []).filter(s => s !== subId);
            return { ...prev, app_submodls: updated, response: updated };
        });
        setRoleAppSubModules(prev => checked ? [...prev, subId] : prev.filter(s => s !== subId));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let valid_Name = true;
        if (!companyId || companyId === "") { setErrCompanyId('Company name is required'); valid_Name = false; } else { setErrCompanyId(''); }
        if (!TEXT_REGEX.test(rolename)) { setErrRoleName('Role name is required'); valid_Name = false; } else { setErrRoleName(''); }
        if (!TEXT_REGEX.test(roledescription)) { setErrRoleDescription('Role description is required'); valid_Name = false; } else { setErrRoleDescription(''); }
        if (!TEXT_REGEX.test(roleshortname)) { setErrRoleShortName('Role short name is required'); valid_Name = false; } else { setErrRoleShortName(''); }
        if (valid_Name) { saveData(); } else { return false; }
    };

    const saveData = () => {
        try {
            console.log('modinfo.modls'); console.log(modinfo.modls);
            let obj = {
                'role_name': rolename,
                'role_short_name': roleshortname,
                'role_details': roledescription,
                'company_id': companyId,
                'module_id': (modinfo.modls ?? []).join(','),
                'sub_module_id': (subModinfo.submodls ?? []).join(','),
                'app_module_id': (app_modinfo.app_modls ?? []).join(','),
                'app_sub_module_id': (app_subModinfo.app_submodls ?? []).join(','),
                'is_chatbot_enabled': isChatbotEnabled,
                'status': '1',
                'created_by': sessionStorage.getItem('LoggedInUserId'),
            };

            if (Roleid !== '' && Roleid !== null) {
                const decryptedBytes = CryptoJS.AES.decrypt(Roleid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                obj['role_ids'] = decrypt_data.roleid;
            }

            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

            saveRole({ 'token': EncryptData }).then(res => {
                if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setDisabled(true);
                    setSuccess(res.data.message);
                    resetUserInfo();
                }
            });
        } catch (err) {
            setSuccess(false);
            setErrMsg(!err?.data ? 'No Server Response' : err.data?.status === 409 ? 'Data already exists' : 'Insert/Update Failed');
        }
    };

    /* ── selection count summary helpers ─────────────────────  */
    const webModCount = modinfo.modls.length;
    const webSubCount = subModinfo.submodls.length;
    const appModCount = app_modinfo.length;
    const appSubCount = app_subModinfo.app_submodls.length;
    const totalSelected = webModCount + webSubCount + appModCount + appSubCount;

    /* ── render module tree ───────────────────────────────────  */
    const renderModuleTree = (data, isApp = false) => {
        const items = data.length > 0 ? data : [];
        if (items.length === 0) return <div className="role-no-data">No modules available</div>;

        return items.map(option => {
            const subItems = isApp ? option.appSubMdlData : option.subMdlData;
            const expandKey = `${isApp ? 'app' : 'web'}-${option.id}`;
            const isExpanded = !!expandedModules[expandKey];
            const isModChecked = isApp
                ? roleAppModules.includes(option.id)
                : modinfo.modls.includes(option.id);

            // Count how many sub-modules of this module are selected
            const selectedSubCount = subItems.filter(s =>
                isApp ? roleAppSubModules.includes(s.id) : subModinfo.submodls.includes(s.id)
            ).length;

            return (
                <div
                    className={`role-module-block${isExpanded ? ' role-module-block--open' : ''}`}
                    key={option.id}
                    id={`module-block-${expandKey}`}
                >
                    {/* Module header row */}
                    <div className="role-module-header">

                        {/* Checkbox */}
                        <label
                            className="role-checkbox-label role-module-label"
                            htmlFor={`${expandKey}-chk`}
                        >
                            <input
                                className="role-checkbox"
                                type="checkbox"
                                id={`${expandKey}-chk`}
                                name={isApp ? "app_modls" : "modls"}
                                value={option.id}
                                onChange={(e) => isApp
                                    ? handleAppModuleChange(e, subItems)
                                    : handleChange(e, subItems)}
                                checked={isModChecked}
                            />
                            <span className="role-checkmark"></span>
                            <span className="role-module-name">{option.module_name}</span>
                        </label>

                        {/* Right-side meta: selected pill + expand toggle */}
                        <div className="role-module-meta">
                            {selectedSubCount > 0 && (
                                <span className="role-selected-pill" title="Selected sub-modules">
                                    {selectedSubCount}/{subItems.length} selected
                                </span>
                            )}
                            {selectedSubCount === 0 && (
                                <span className="role-badge">{subItems.length} sub</span>
                            )}

                            {subItems.length > 0 && (
                                <button
                                    type="button"
                                    id={`toggle-${expandKey}`}
                                    className={`role-toggle-btn${isExpanded ? ' role-toggle-btn--open' : ''}`}
                                    onClick={() => toggleExpand(expandKey)}
                                    aria-expanded={isExpanded}
                                    aria-controls={`sublist-${expandKey}`}
                                    title={isExpanded ? 'Collapse sub-modules' : 'Expand sub-modules'}
                                >
                                    <span className="role-toggle-icon">+</span>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Sub-module list — animated expand/collapse */}
                    {subItems.length > 0 && (
                        <div
                            id={`sublist-${expandKey}`}
                            className={`role-submodule-list${isExpanded ? ' role-submodule-list--open' : ''}`}
                        >
                            {subItems.map(subitem => {
                                const isSubChecked = isApp
                                    ? roleAppSubModules.includes(subitem.id)
                                    : subModinfo.submodls.includes(subitem.id);
                                return (
                                    <label
                                        className={`role-checkbox-label role-submodule-label${isSubChecked ? ' role-submodule-label--checked' : ''}`}
                                        htmlFor={`${isApp ? 'app' : 'web'}-sub-${subitem.id}`}
                                        key={subitem.id}
                                    >
                                        <input
                                            className="role-checkbox"
                                            type="checkbox"
                                            id={`${isApp ? 'app' : 'web'}-sub-${subitem.id}`}
                                            name={isApp ? "app_submodls" : "submodls"}
                                            value={subitem.id}
                                            onChange={isApp ? handleAppSubMdlChange : handleSubMdlChange}
                                            checked={isSubChecked}
                                        />
                                        <span className="role-checkmark role-checkmark--sub"></span>
                                        <span className="role-submodule-name">{subitem.sub_module_name}</span>
                                        {isSubChecked && <span className="role-submodule-tick">✓</span>}
                                    </label>
                                );
                            })}
                        </div>
                    )}
                </div>
            );
        });
    };

    const tabs = [
        { id: 1, label: 'Role Details', icon: '👤' },
        { id: 2, label: 'Web Module', icon: '🌐' },
        { id: 3, label: 'App Module', icon: '📱' },
    ];

    return (
        <div id="role-container" className="role-container">
            <div className="role-header">
                <h2 className="role-title">
                    <span className="role-title-icon">🔐</span>
                    {Roleid ? 'Edit Role' : 'Add Role'}
                </h2>
                <p className="role-subtitle">Configure role permissions and module access</p>
            </div>

            {/* ── Selection summary bar ───────────────────────── */}
            {totalSelected > 0 && (
                <div id="role-selection-bar" className="role-selection-bar">
                    <span className="role-selection-bar-icon">📋</span>
                    <span className="role-selection-bar-label">Selected:</span>
                    {(webModCount > 0 || webSubCount > 0) && (
                        <span className="role-selection-chip role-selection-chip--web">
                            🌐 {webModCount} module{webModCount !== 1 ? 's' : ''}
                            {webSubCount > 0 && <> · {webSubCount} sub</>}
                        </span>
                    )}
                    {(appModCount > 0 || appSubCount > 0) && (
                        <span className="role-selection-chip role-selection-chip--app">
                            📱 {appModCount} module{appModCount !== 1 ? 's' : ''}
                            {appSubCount > 0 && <> · {appSubCount} sub</>}
                        </span>
                    )}
                    <span className="role-selection-total">{totalSelected} total</span>
                </div>
            )}

            {/* Alerts */}
            {success && (
                <div id="role-alert-success" className="role-alert role-alert--success">
                    <span className="role-alert-icon">✅</span> {success}
                </div>
            )}
            {errMsg && !success && (
                <div id="role-alert-error" className="role-alert role-alert--error">
                    <span className="role-alert-icon">⚠️</span> {errMsg}
                </div>
            )}

            {/* Tab Nav */}
            <div id="role-tabs" className="role-tabs">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        id={`role-tab-${tab.id}`}
                        className={`role-tab-btn${activeTab === tab.id ? ' role-tab-btn--active' : ''}`}
                        onClick={() => handleTabChange11(tab.id)}
                        type="button"
                    >
                        <span className="role-tab-icon">{tab.icon}</span>
                        <span className="role-tab-label">{tab.label}</span>
                        {/* Show count badge on tab if something selected */}
                        {tab.id === 2 && (webModCount + webSubCount) > 0 && (
                            <span className="role-tab-count">{webModCount + webSubCount}</span>
                        )}
                        {tab.id === 3 && (appModCount + appSubCount) > 0 && (
                            <span className="role-tab-count">{appModCount + appSubCount}</span>
                        )}
                    </button>
                ))}
            </div>

            <form id="role-form" onSubmit={handleSubmit} className="role-form">

                {/* ── Tab 1: Role Details ─────────────────────── */}
                {activeTab === 1 && (
                    <div id="role-tab-panel-1" className="role-tab-panel">
                        <div className="role-field-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="role-field-label" htmlFor="role-company-select">
                                        Company Name <span className="role-required">*</span>
                                    </label>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        id="role-company-select"
                                        className="role-select"
                                        onChange={handleCompanyId}
                                        value={companyId}
                                    >
                                        <option value="">Select Company</option>
                                        {companies.length > 0
                                            ? companies.map(opt => (
                                                <option key={opt.company_id} value={opt.company_id}>{opt.company_name}</option>
                                            ))
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrCompanyId && <span className="role-field-error">{ErrCompanyId}</span>}
                                </div>
                            </div>
                        </div>

                        <div className="role-field-group">
                            <FromFieldText star="*" label="Role Code" inputValue={roleshortname} setInputValue={setRoleShortName} setErrorMsg={ErrRoleShortName} />
                        </div>
                        <div className="role-field-group">
                            <FromFieldText star="*" label="Role Name" inputValue={rolename} setInputValue={setRoleName} setErrorMsg={ErrRoleName} />
                        </div>
                        <div className="role-field-group">
                            <FromFieldText star="*" label="Role Description" inputValue={roledescription} setInputValue={setRoleDescription} setErrorMsg={ErrRoleDescription} />
                        </div>

                        <div className="role-field-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="role-field-label">Enable Chatbot</label>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="role-select"
                                        onChange={(e) => setIsChatbotEnabled(e.target.value)}
                                        value={isChatbotEnabled}
                                    >
                                        <option value="0">No / Inactive</option>
                                        <option value="1">Yes / Active</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="role-actions">
                            <button id="role-next-btn-1" type="button" className="role-btn role-btn--primary" onClick={() => validateTab1AndProceed(2)}>
                                Next <span>→</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* ── Tab 2: Web Module ───────────────────────── */}
                {activeTab === 2 && (
                    <div id="role-tab-panel-2" className="role-tab-panel">
                        <div className="role-module-section">
                            <div className="role-module-section-header">
                                <div>
                                    <h4 className="role-module-section-title">🌐 Web Modules</h4>
                                    <p className="role-module-section-desc">
                                        Check a module to select it. Click <strong>+</strong> to expand and pick individual sub-modules.
                                    </p>
                                </div>
                                {(webModCount + webSubCount) > 0 && (
                                    <div className="role-module-count-badge">
                                        <span className="role-module-count-num">{webModCount + webSubCount}</span>
                                        <span className="role-module-count-label">selected</span>
                                    </div>
                                )}
                            </div>
                            <div id="role-web-modules" className="role-module-tree">
                                {renderModuleTree(modulesData, false)}
                            </div>
                        </div>
                        <div className="role-actions">
                            <button id="role-next-btn-2" type="button" className="role-btn role-btn--secondary" onClick={() => handleTabChange11(1)}>
                                <span>←</span> Back
                            </button>
                            <button id="role-next-btn-2-fwd" type="button" className="role-btn role-btn--primary" onClick={() => handleTabChange11(3)}>
                                Next <span>→</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* ── Tab 3: App Module ───────────────────────── */}
                {activeTab === 3 && (
                    <div id="role-tab-panel-3" className="role-tab-panel">
                        <div className="role-module-section">
                            <div className="role-module-section-header">
                                <div>
                                    <h4 className="role-module-section-title">📱 App Modules</h4>
                                    <p className="role-module-section-desc">
                                        Check a module to select it. Click <strong>+</strong> to expand and pick individual sub-modules.
                                    </p>
                                </div>
                                {(appModCount + appSubCount) > 0 && (
                                    <div className="role-module-count-badge">
                                        <span className="role-module-count-num">{appModCount + appSubCount}</span>
                                        <span className="role-module-count-label">selected</span>
                                    </div>
                                )}
                            </div>
                            <div id="role-app-modules" className="role-module-tree">
                                {renderModuleTree(appModulesData, true)}
                            </div>
                        </div>
                        <div className="role-actions">
                            <button id="role-back-btn-3" type="button" className="role-btn role-btn--secondary" onClick={() => handleTabChange11(2)}>
                                <span>←</span> Back
                            </button>
                            <button id="role-save-btn" className="role-btn role-btn--save" disabled={disabled}>
                                💾 Save Role
                            </button>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
}

export default Role;